﻿import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { NoteObject } from '../models/note-object';
import { NoteType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';
import NotesEditor from './NoteEditor';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import HtmlEditor from 'devextreme-react/html-editor';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';

export interface Props {
    productId?: string;
    batchId?: string;
    height?: string;
    headerColor?: string;
}

export default function ProductionBenchSheetPlanningNotesViewer(props: Props) {
    const [note, setNote] =
        useState<NoteObject>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        getProductionBenchSheetPlanningNotes();
    }, [props.productId, props.batchId]);

    return (
        <div>
            <div className={`lq-header pw-margin-top-05 ${props.headerColor ? props.headerColor : 'pw-bg-purple'}`}>
                <div className="lq-header-title">{'Planning Notes'}</div>
                <div className="title-bar-spacer" />

                {props.productId && props.batchId &&
                    <NavLink to={`/pbs-planning-notes-viewer-fp/${props.productId}/${props.batchId}`}
                        className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                        <Button text="" icon="panelleft" type="success"
                            className="title-bar-button"
                            hint="open in new tab" />
                    </NavLink>
                }
                
                {/*
                <div>
                    <Button className="title-bar-button"
                        text="" icon="pdffile" type="success"
                        hint="export to pdf"
                        onClick={exportToPdf} />
                </div>   
                */}

            </div>

            <div id="productionBenchSheetPlanningNotesViewerContainer" className="pw-form-section">
                <HtmlEditor height={props.height ? props.height : "100%"} readOnly={true}
                    value={note && note.text ? note.text : undefined} />
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    /*
    async function exportToPdf() {
        if (props.parentId && props.noteType) {
            await CrudFunctions.getDataBlob(`notes/notetopdf/${props.parentId}/${props.noteType}`)
                .then(blob => {
                    let a = document.createElement("a") as HTMLAnchorElement;

                    document.body.appendChild(a);
                    a.style.display = "none";

                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = `${props.title ? props.title : 'note'}.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(url);

                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Note");
                });
        }
    }
    */

    // get functions

    async function getProductionBenchSheetPlanningNotes() {
        if (!props.productId)
            return;

        if (!dataLoaded && props.productId !== '00000000-0000-0000-0000-000000000000' && props.batchId) {
            await CrudFunctions.getData(`notes/productionbenchsheetplanningnotes/${props.productId}/${props.batchId}`)
                .then(data => {
                    if (data) {
                        setDataLoaded(true);

                        let returnedNotes = data as NoteObject;

                        if (returnedNotes) {
                            returnedNotes.text = atob(returnedNotes.base64Blob);
                            setNote(returnedNotes);
                        }
                    }
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Note");
                });
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}


